export default {
  sideMenu:{
    "batch_server":"批量服务",
    "custom_server": "客户服务",
    "trans_authserver": "授权服务",
    "clear_server": "清分清算",
    "quota_server": "额度服务",
    "amortized_server": "分期及消贷",
    "operation_center": "运营中心",
    "configuration_center": "配置中心",
    "officialcard_server":"公务卡服务",
    "openapi_server":"OPEN API服务",
    "base_server":"基础服务",
    "muse-nofn001":"信用卡服务",
    "ecny-mall-server":"商城管理",
    "boc_mall_merchant_server":"商城-商户端",
    "boc_mall_supplier_server":"商城-供应商端",
    custom_info_management: "客户信息管理",
    custom_basic_business: "基础业务受理",
    custom_basic_business_bind: "媒介信息绑定",
    custom_basic_business_activate: "媒介激活",
    custom_basic_business_report: "媒介挂失",
    custom_basic_business_reissue: "媒介损毁补发",
    custom_basic_business_cancel: "媒介注销",
    custom_basic_business_espsit: "特别状况设置",
    custom_basic_business_esprelieve: "特别状况解除",
    custom_basic_business_cardprinting: "实时制卡",
    custom_basic_business_deductionsit: "约定扣款设置",
    custom_basic_business_renewcard: "提前续卡",
    custom_basic_business_productcancel: "客户产品注销",
    custom_basic_business_interestrate: "统一利率",
    custom_basic_business_cardsetquery: "关联套卡查询",
    custom_basic_business_productrank: "产品升降级",
    custom_basic_business_statusmaintain: "核算状态维护",
    custom_basic_business_dateupdate: "统一日期修改",
    custom_basic_business_carddistribute: "预制卡分配",
    custom_quick_apply: "客户快捷申请",
    custom_basic_adjusttrans: "手工调整交易",
    custom_basic_adjusttrans_debit: "本金借记交易补录",
    custom_basic_adjusttrans_credit: "本金贷记交易补录",
    custom_basic_adjusttrans_repayment: "还款交易补录",
    custom_basic_adjusttrans_interest: "利息调整补录",
    custom_basic_adjusttrans_cost: "费用调整补录",
    custom_basic_adjusttrans_exception: "异常交易管理",
    custom_info_management_query: "客户信息查询维护",
    custom_info_management_addressquery: "地址信息查询维护",
    custom_basic_business_billdate: "修改账单日",
    custom_account_info: "账务信息管理",
    custom_account_info_query: "账户金融信息查询",
    custom_account_info_delay: "客户延滞状况查询",
    custom_account_info_unpaidbill: "未出账单查询",
    custom_account_info_billed: "已出账单查询",
    custom_account_info_cal: "非余额变动核算查询",
    custom_trans_info: "交易信息查询",
    custom_trans_info_finance: "金融交易查询",
    custom_trans_info_repayhis: "客户还款历史查询",
    custom_trans_info_statistics: "客户交易统计查询",
    custom_trans_info_fx: "结售汇记录查询",
    custom_trans_info_unit: "交易单元查询",
    custom_interest_manage: "利息信息管理",
    custom_interest_settle_query: "结息查询",
    custom_interest_trial: "利息试算",
    custom_interest_accum: "利息累计",
    custom_interest_adjust: "利息贷调",
    "custom_unified_view": "客户统一视图",
    "custom_unified_view_business": "客户业务项目",
    "custom_unified_view_account": "客户账户视图",
    "custom_unified_view_control": "客户管控视图",
    "custom_unified_view_product": "客户产品视图",
    "custom_unified_view_medium": "客户媒介视图",
    "custom_unified_view_price": "客户定价视图",
    "custom_expense_info": "费用信息管理",
    "custom_expense_info_loan": "费用贷调",
    "custom_expense_info_valueadded": "客户增值服务费",
    "custom_expense_info_query": "客户费用信息查询",
    "trans_authserver_cust_manage_info": "客户信息查询",
    "trans_authserver_cust_manage_medium": "媒介信息查询",
    "trans_authserver_cust_manage_card": "发卡例外名单",
    "trans_authserver_cust_manage_cheat": "授权欺诈名单",
    "trans_authserver_cust_manage_cumulative": "交易累计查询",
    "trans_authserver_cust_manage_password": "客户设置密码",
    "trans_authserver_cust_manage_auth": "授权例外名单",
    "trans_authserver_cust_manage_verify": "消费验密设置",
    "trans_authserver_cust_manage_cumulativehis": "交易累计历史查询",
    "trans_authserver_cust_manage": "客户管理",
    "trans_authserver_trans_manage_today": "当日交易查询",
    "trans_authserver_trans_manage_his": "历史交易查询",
    "trans_authserver_trans_manage_preauth": "预授权查询",
    "trans_authserver_trans_manage_unrecorded": "未入账交易查询",
    "trans_authserver_trans_manage_input": "授权交易录入",
    "trans_authserver_trans_manage": "交易管理",
    "trans_authserver_control_manage_trans": "交易管控",
    "trans_authserver_control_manage_posandneg": "正负面清单",
    "trans_authserver_control_manage_excep": "例外清单",
    "trans_authserver_control_manage_control": "管控清单",
    "trans_authserver_control_manage_second": "副卡限制",
    "trans_authserver_control_manage": "交易管控管理",
    "trans_authserver_scene_manage_auth": "授权场景",
    "trans_authserver_scene_manage_trans": "交易场景",
    "trans_authserver_scene_manage_error": "授权错误码",
    "trans_authserver_scene_manage_resp": "外部响应码",
    "trans_authserver_scene_manage": "授权场景管理",
    "trans_authserver_market_manage_inventory": "营销清单管理",
    "trans_authserver_market_manage_scene": "营销场景管理",
    "trans_authserver_market_manage": "营销管控",
    "trans_authserver_nation_manage_channels": "国际组织网络管理",
    "trans_authserver_nation_manage_params": "国际组织参数管理",
    "trans_authserver_nation_manage_network": "网络链接状态",
    "trans_authserver_nation_manage": "国际组织管理",
    "trans_authserver_encrypt_manage_index": "密钥索引管理",
    "trans_authserver_encrypt_manage_secretkey": "密钥管理",
    "trans_authserver_encrypt_manage": "加密机管理",
    "custom_his_query": "历史信息查询",
    "custom_his_query_spec": "特别状况历史",
    "custom_his_query_nonf": "非金融维护历史查询",
    "custom_pricing_info": "定价信息管理",
    "custom_pricing_info_label": "客户定价标签",
    "custom_pricing_info_personal": "客户个性化标签",
    "clear_server_refuse": "拒绝交易管理",
    "clear_server_process": "清算处理结果",
    "clear_server_scene": "清算场景管理",
    "clear_server_channel": "清算渠道管理",
    "amortized_server_spreadmanage": "分期管理",
    "amortized_server_payment": "贷款支付信息",
    "amortized_server_trial": "贷款试算器",
    "amortized_server_srepayloan": "无账期消贷申请",
    "amortized_server_repayloan": "普通消贷申请",
    "amortized_server_trans": "交易分期申请",
    "amortized_server_bill": "账单分期申请",
    "amortized_server_special": "专项分期申请",
    "amortized_server_cash": "现金分期申请",
    "amortized_server_acct": "交易账户信息",
    "quota_server_quotanet": "额度网",
    "quota_server_nodemanage": "额度节点管理",
    "quota_server_quotaadjust": "客户额度调整",
    "quota_server_quotacredit": "客户额度授信",
    "quota_server_quotahis": "调额历史查询",
    "quota_server_balancequery": "实时余额查询",
    "quota_server_mediumquery": "媒介额度查询",
    "quota_server_custquery": "客户额度查询",
    "operation_center_assets": "资产管理",
    "operation_center_assets_buyback": "回购法人标志维护",
    "operation_center_assets_legalperson": "资金法人",
    "operation_center_assets_agreement": "资金协议",
    "operation_center_assets_securitisation": "资产证券化查询",
    "operation_center_assets_choice": "资产选择",
    "operation_center_assets_abspro": "ABS计划管理",
    "operation_center_calculation": "核算管理",
    "operation_center_calculation_subscene": "核算子场景",
    "operation_center_calculation_mainscene": "核算主场景",
    "operation_center_calculation_internalbill": "记账规则子表-内部帐类",
    "operation_center_calculation_subjecttable": "记账规则子表-科目类",
    "operation_center_calculation_maintable": "记账规则主表",
    "operation_center_nummatch": "配号管理",
    "operation_center_nummatch_request": "卡号池请求",
    "operation_center_nummatch_apply": "预制卡申请",
    "operation_center_nummatch_query": "卡号池查询",
    "operation_center_nummatch_list": "预留号码清单",
    "operation_center_nummatch_cards": "预留号码卡量",
    "operation_center_nummatch_specialrules": "特殊号码规则",
    "operation_center_nummatch_cardbin": "卡BIN",
    "operation_center_nummatch_binrange": "卡BinRange",
    "operation_center_manage": "运营管理",
    "operation_center_manage_sourcelist": "来源目录",
    "operation_center_manage_source": "交易来源",
    "operation_center_manage_repayorder": "还款顺序",
    "operation_center_manage_specialsit": "特别状况",
    "operation_center_manage_cardpage": "卡版管理",
    "operation_center_manage_function": "功能管控码",
    "operation_center_manage_project": "管控项目",
    "operation_center_manage_calculation": "核算状态码",
    "operation_center_manage_transid": "交易识别码",
    "operation_center_manage_operationorg": "运营机构",
    "operation_center_manage_operationmode": "运营模式",
    "operation_center_price": "定价管理",
    "operation_center_price_interestrate": "利率目录",
    "operation_center_price_charge": "收费目录",
    "operation_center_price_exchangerate": "汇率目录",
    "operation_center_price_trans": "交易定价",
    "operation_center_price_tag": "定价标签",
    "operation_center_model": "产品模型管理",
    "operation_center_model_techparams": "技术参数",
    "operation_center_model_elementinstance": "元件通用实例化",
    "operation_center_model_elementrange": "元件应用范围",
    "operation_center_model_stagetype": "分期类型",
    "operation_center_model_balance": "余额对象",
    "operation_center_model_medium": "媒介对象",
    "operation_center_model_businesstype": "业务类型",
    "operation_center_model_businessproject": "业务项目",
    "operation_center_paramview": "产品参数一览",
    "operation_center_parammaintain": "产品参数维护",
    "operation_center_newproduct": "新产品发布",
    "configuration_center_eventlist": "事件清单",
    "configuration_center_activitylist": "活动清单",
    "configuration_center_holidays_maintain": "节假日维护",
    "configuration_center_componentlist": "构件清单",
    "configuration_center_elementlist": "元件清单",
    "configuration_center_currencylist": "货币清单",
    "configuration_center_countryRegion": "国家地区",
    "configuration_center_payservice": "收费项目",
    "configuration_center_legalperson": "法人实体",
    "configuration_center_system": "系统单元",
    "configuration_center_holidays_setup": "节假日设置",
    "configuration_center_holidays": "节假日管理",
    "configuration_center_businessform": "业务形态",
    "configuration_center_lifecyclenode": "生命周期节点",
    "configuration_center_serialnumberlist": "序号清单",
    "configuration_center_sceneengine_who": "客群",
    "configuration_center_sceneengine_when": "时期",
    "configuration_center_sceneengine_where": "渠道和地点",
    "configuration_center_sceneengine_how": "媒介和手段",
    "configuration_center_sceneengine_why": "用信目的",
    "configuration_center_sceneengine_rule": "场景规则",
    "configuration_center_sceneengine": "场景化引擎",
    "configuration_center_pricingmodel_price": "定价",
    "configuration_center_pricingmodel_charge": "收费",
    "configuration_center_pricingmodel_interest": "计息",
    "configuration_center_pricingmodel_magreement": "资方协议信息",
    "configuration_center_pricingmodel_mlegalperson": "资方法人",
    "configuration_center_pricingmodel": "定价模型",
    "officialcard_server_budgetbuild": "预算单位建立",
    "officialcard_server_budgetmaintain": "预算单位维护",
    "officialcard_server_mediaactivation": "媒介激活",
    "officialcard_server_productcancel": "客户产品注销",
    "officialcard_server_quotaservice": "公务卡额度服务管理",
    "officialcard_server_transquery": "金融交易查询",
    "officialcard_server_outbillquery": "未出账单查询",
    "officialcard_server_billquery": "已出账单查询",
    "officialcard_server_budgetbillquery": "预算单位账单查询",
    "officialcard_server_productoutage": "客户产品停用",
    "officialcard_server_transfer": "预算单位溢缴款转出",
    "rule_server": "风控平台",
    "approve_server": "进件审批",
    "aps_server": "进件申请",
  }
}